import { useMutation, useQueryClient } from '@tanstack/react-query';
import { retentionAdminApi } from '../api/retentionAdminApi';
import type { UpdateRetentionPolicyRequest } from '../types/retentionAdmin';

/**
 * PUT /api/eraf/retention-admin/policies/{id} — 보존 정책 수정 (RETENTION_MANAGE)
 */
export function useUpdatePolicy() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: UpdateRetentionPolicyRequest }) =>
      retentionAdminApi.updatePolicy(id, body),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({ queryKey: ['retention-admin', 'list'] });
      void qc.invalidateQueries({ queryKey: ['retention-admin', 'detail', vars.id] });
    },
  });
}
